<template>
  <div style="height: 100%" v-if="$store.state.user.id == shop.user_id">
    <!--<v-overlay v-model="loading">
      <v-progress-circular
        :size="100"
        :width="7"
        color="#4B2A66"
        indeterminate
      ></v-progress-circular>
    </v-overlay>-->
    <v-sheet >
      <v-container class="d-flex justify-center pt-0">
        <v-col class="ma-0 pa-0">
          <v-container>
            <v-row class="d-flex justify-center" no-gutters>
              <v-col cols="12" class="d-flex justify-center ma-0 pa-0">
                <v-text-field
                  v-model="productsQuery"
                  @change="search(productsQuery)"
                  label="Buscar na Loja"
                  block
                  solo
                  outlined
                >
                  <template #append>
                    <v-btn
                      icon
                      class="ma-0 pa-0"
                      @click="search(productsQuery)"
                    >
                      <v-icon>mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <div>
              <v-card max-width="100%" class="mx-auto">
                <v-col class="d-flex" :class="$vuetify.breakpoint.xs ? 'justify-center' : ''">
                  <v-dialog v-model="addproduct" width="80%" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="openProductDialog()"
                        color="#4B2A66"
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        Adicionar Produto<v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <v-form ref="productForm">
                      <v-card
                        class="pa-2 elevation-10"
                        height="100%"
                        width="100%"
                      >
                        <input
                          ref="fileInput"
                          type="file"
                          accept="image/png, image/jpeg, image/bmp"
                          @input="pickFile"
                          class="d-none"
                        />
                        <v-container>
                          <v-row justify="space-between">
                            <v-col cols="12" md="6">
                              <v-card
                                class="elevation-10 pa-2 d-flex align-center justify-center"
                              >
                                <img
                                  v-if="product.images.length == 0"
                                  v-show="visibleLogo"
                                  src="@/assets/logo-map-marker.svg"
                                  width="300"
                                />
                                <v-img
                                  v-else
                                  :src="product.images[0]"
                                  width="300"
                                  height="400"
                                  contain
                                />
                              </v-card>

                              <div class="mt-2 mb-4">
                                <div class="text-subtitle-2 mb-1">
                                  Imagens Adicionadas:
                                </div>
                                <draggable
                                  v-model="products.images"
                                  draggable=".draggable"
                                  :animation="150"
                                  class="d-flex flex-wrap"
                                >
                                  <template
                                    v-for="(img, i) in product.images.concat(
                                      undefined
                                    )"
                                  >
                                    <v-card
                                      :key="i"
                                      height="80px"
                                      width="80px"
                                      color="transparent"
                                      :class="{ draggable: !!img }"
                                      class="ma-1"
                                    >
                                      <div
                                        v-if="img"
                                        style="
                                          position: absolute;
                                          z-index: 1;
                                          width: 100%;
                                        "
                                      >
                                        <v-tooltip top>
                                          <span> Remover Imagem </span>
                                          <template #activator="{ on }">
                                            <v-btn
                                              x-small
                                              fab
                                              color="warning"
                                              class="float-right ma-1"
                                              v-on="on"
                                              @click="
                                                product.images.splice(i, 1)
                                              "
                                            >
                                              <v-icon small>mdi-delete</v-icon>
                                            </v-btn>
                                          </template>
                                        </v-tooltip>
                                      </div>
                                      <v-img
                                        height="100%"
                                        width="100%"
                                        :src="img"
                                        contain
                                        @click="
                                          additionalImageIndex = i;
                                          $refs.additionalImageInput.click();
                                        "
                                      >
                                        <template v-if="!img">
                                          <v-sheet
                                            color="transparent"
                                            height="100%"
                                            class="elevation-10 d-flex align-center justify-center"
                                          >
                                            <v-icon color="#4B2A66" x-large
                                              >mdi-plus</v-icon
                                            >
                                          </v-sheet>
                                        </template>
                                      </v-img>
                                    </v-card>
                                  </template>
                                </draggable>
                              </div>
                              <input
                                ref="additionalImageInput"
                                type="file"
                                accept="image/png, image/jpeg, image/jpg, image/bmp"
                                @input="pickAdditionalImage"
                                class="d-none"
                              />

                              <v-alert
                                v-model="alertImage"
                                dense
                                outlined
                                type="error"
                                transition="scale-transition"
                              >
                                Selecione uma imagem!
                              </v-alert>
                            </v-col>

                            <v-col cols="12" md="6" class="text-center px-0">
                              <v-container>
                                <!-- <v-row justify="end">
                                                            <v-col cols="6" md="4" class="d-flex justify-end">
                                                                <v-title>Disponivel para:</v-title>
                                                            </v-col>
                                                            <v-col cols="5" md="3" class="d-flex justify-center">
                                                                <v-btn text outlined class="mr-2 red-darken-1">Somente eu</v-btn>
                                                            </v-col>
                                                            <v-col cols="5" md="3" class="d-flex justify-center">
                                                                <v-btn text outlined>
                                                                    Editar<v-icon color="blue">mdi-pencil-outline</v-icon>
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>-->
                                <v-col
                                  class="d-flex justify-start"
                                  cols="12"
                                  ><v-text-field
                                    v-model="product.name"
                                    label="Nome do Produto *"
                                    :rules="[$rules.required]"
                                    outlined
                                    hide-details="auto"
                                  />
                                </v-col>
                                <v-col
                                  class="d-flex justify-start "
                                  cols="12"
                                >
                                  <v-text-field
                                    v-model="product.category"
                                    outlined
                                    dense
                                    chips
                                    small-chips
                                    label="Categoria"
                                    multiple
                                    deletable-chips
                                    hide-details="auto"
                                  />
                                </v-col>
                                <v-col cols="12" class="mt-0 pt-0">
                                  <v-chip-group
                                    active-class="pink--text"
                                    small-chips
                                    column
                                  >
                                    <v-chip
                                      v-for="category in categories"
                                      :key="category"
                                      @click="product.category = category"
                                    >
                                      {{ category }}
                                    </v-chip>
                                  </v-chip-group>
                                </v-col>
                                <v-col class="d-flex justify-start">
                                  <v-textarea
                                    v-model="product.description"
                                    label="Descrição"
                                    outlined
                                    hide-details="auto"
                                  />
                                </v-col>
                                  <div :class="!$vuetify.breakpoint.xs ? 'd-flex' : ''">
                                  <v-col cols="12" sm="6">
                                    <v-text-field
                                      v-model="product.value"
                                      label="Valor *"
                                      prefix="R$"
                                      type="number"
                                      step="0.01"
                                      placeholder="0,00"
                                      :rules="[$rules.required]"
                                      required
                                      outlined
                                      hide-details="auto"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="6">
                                    <v-text-field
                                      v-model="product.promotional_value"
                                      label="Valor Promocional"
                                      type="number"
                                      prefix="R$"
                                      step="0.01"
                                      placeholder="0,00"
                                      outlined
                                      hide-details="auto"
                                    ></v-text-field>
                                  </v-col>
                                  </div>
                                <v-divider />
                                <!--<v-col class="d-flex justify-start align-center ma-2 pa-0 mb-4">
                                                            <v-avatar>
                                                                <img src="@/assets/olhadela_logo.png" alt="John">
                                                            </v-avatar>
                                                            <v-title class="ml-2 text-h6">{{name_shop}}</v-title>
                                                        </v-col>
                                                        <v-card>
                                                            <v-img src="@/assets/google_maps.jpg" height="150px" />
                                                        </v-card>
                                                        <v-col>
                                                            <v-btn icon class="ma-1" :href="shop.whatsapp_link">
                                                                <v-icon size="30" color="green">mdi-whatsapp</v-icon>
                                                            </v-btn>
                                                            <v-btn icon class="ma-1" :href="shop.telephone_link">
                                                                <v-icon size="30">mdi-phone</v-icon>
                                                            </v-btn>
                                                            <v-btn icon class="ma-1" :href="shop.facebook_link">
                                                                <v-icon size="30" color="blue">mdi-facebook</v-icon>
                                                            </v-btn>
                                                            <v-btn icon class="ma-1" :href="shop.instagram_link">
                                                                <v-icon size="30" color="pink">mdi-instagram</v-icon>
                                                            </v-btn>

                                                        </v-col>-->
                                <v-divider />
                                <div align="end" class="pt-3">
                                  <v-btn
                                    @click="
                                      (addproduct = false),
                                        (cont = 0),
                                        (model = 0)
                                    "
                                    color="#4B2A66"
                                    class="mx-1"
                                    outlined
                                  >
                                    Cancelar
                                  </v-btn>
                                  <v-btn
                                    v-show="save"
                                    color="#4B2A66"
                                    @click="createProduct"
                                    dark
                                    class="px-6"
                                  >
                                    Salvar
                                  </v-btn>
                                  <v-btn
                                    v-show="saveAlteracoes"
                                    color="#4B2A66"
                                    dark
                                    class="px-6"
                                    @click="updateProduct(product_id)"
                                  >
                                    Salvar
                                  </v-btn>
                                </div>
                              </v-container>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                    </v-form>
                  </v-dialog>
                </v-col>
                <v-col>
                  <v-card-title class="text-h6" :class="$vuetify.breakpoint.xs ? 'justify-center' : ''">Produtos</v-card-title>
                </v-col>

                <v-list subheader v-if="products.length > 0">
                  <v-list-item v-for="product in products" :key="product.title">
                    <v-list-item-avatar size="150" tile class="pa-2">
                      <v-card class="elevation-10">
                      <v-img
                        :src="
                          product.images.length == 0
                            ? undefined
                            : product.images[0]
                        "
                      ></v-img>
                      </v-card>
                    </v-list-item-avatar>
                    <div>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-h6"
                        @click="
                          dataProduct(product.url_product),
                            (addproduct = true),
                            (save = false),
                            (saveAlteracoes = true)
                        "
                        >{{ product.product }}
                      </v-list-item-title>
                      {{ product.viewed_products }} visualizações |
                      {{ product.saved }} vezes salvo</v-list-item-content
                    >
                    
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="#4B2A66"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            dataProduct(product.url_product),
                              (addproduct = true),
                              (save = false),
                              (saveAlteracoes = true)
                          "
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>Editar Produto</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          color="#4B2A66"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            (deleteConfirm = true),
                              (deleteProduct = product._id)
                          "
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>Excluir Produto</span>
                    </v-tooltip>
                    </div>
                  </v-list-item>
                </v-list>
                <p
                  v-if="products.length == 0 && changingProducts == false"
                  style="text-align: center"
                >
                  Nenhum produto cadastrado!
                </p>
                <v-row
                  dense
                  v-show="visible"
                  class="mx-auto mt-n4"
                  max-width="100%"
                >
                  <v-col>
                    <v-card class="elevation-5" height="auto">
                      <v-row>
                        <v-col cols="auto" class="ml-5">
                          <v-card-title>
                            Nenhum resultado encontrado!
                          </v-card-title>
                        </v-col>
                      </v-row>
                      <v-divider />
                    </v-card>
                  </v-col>
                </v-row>
                <v-divider />
              </v-card>
            </div>
          </v-container>
        </v-col>
      </v-container>
    </v-sheet>
    <v-dialog v-model="deleteConfirm" width="400" class="pa-2">
      <v-card>
        <v-card-title> Excluir Produto </v-card-title>
        <v-card-text>
          Tem certeza que deseja excluir esse produto?
        </v-card-text>
        <v-divider />
        <v-card-actions class="justify-end d-flex">
          <v-btn
            color="#4B2A66"
            outlined
            text
            dark
            @click="deleteConfirm = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            dark
            color="#4B2A66"
            @click="hideProduct(deleteProduct), (deleteConfirm = false)"
          >
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="productAdded" width="500">
      <v-card class="pa-2">
        <v-card-title class="justify-center">
          Produto Adicionado!
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="#4B2A66" @click="productAdded = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data: () => ({
    product: {
      name: "",
      description: "",
      category: "",
      value: undefined,
      promotional_value: null,
      images: [],
    },
    deleteProduct: undefined,
    deleteConfirm: false,
    categories: [],
    value: null,
    additionalImageIndex: -1,
    changingProducts: false,
    visible: false,
    productsQuery: "",
    loading: false,
    alertImage: false,
    visibleImage: false,
    visibleLogo: true,
    row: null,
    drawer: true,
    addproduct: false,
    pagemenu: false,
    shop: [],
    name_shop: "",
    id_shop: "",
    id_city: "",
    city: [],
    state: "",
    files: [],
    previewImage: null,
    save: true,
    saveAlteracoes: false,
    productAdded: false,
    products: [],
    //product: [
    //{
    //color: "#952175",
    //src: "https://picsum.photos/500/300?random",
    //title: "Name",
    //},
    //],
  }),
  mounted() {
    this.loadProducts();
  },
  methods: {
    loadProducts() {
      this.loading = true;
      this.$axios
        .get("/shop/" + this.$route.params.shop_url)
        .then((response) => {
          this.shop = response.data;
          document.title = `Olhadela - ${this.shop.shop_name}`;
          if (this.$store.state.user.id != this.shop.user_id) {
            this.$router.replace({
              path: "/negocio/" + this.$route.params.shop_url,
            });
          } else {
            this.name_shop = response.data.shop_name;
            this.id_shop = response.data.id;
            this.id_city = response.data.city_id;
            this.$axios.get("/products/" + this.id_shop).then((response) => {
              this.products = response.data;
            });
            this.$axios.get("/city/" + this.id_city).then((response) => {
              this.city = response.data;
              this.$axios
                .get("/state/" + response.data.state_id)
                .then((response) => {
                  this.state = response.data.uf;
                });
            });
            this.$axios.get("categories/" + this.id_shop).then((response) => {
              this.categories = response.data;
            });
            this.loading = false;
          }
        });
    },
    openProductDialog() {
      this.product.images = [];
      this.save = true;
      this.saveAlteracoes = false;
      this.visibleImage = false;
      this.visibleLogo = true;
      this.$nextTick(() => {
        this.$refs.productForm.reset();
      });
    },
    createProduct() {
      if (this.$refs.productForm.validate() && this.product.images) {
        this.$axios
          .post("/product/" + this.id_shop, this.product)
          .finally(() => {
            this.loadProducts();
          });

        this.addproduct = false;
        this.openProductDialog();
        this.productAdded = true;
      } else if (this.product.images.length == 0) {
        this.alertImage = true;
      }
    },
    dataProduct(url_product) {
      this.visibleImage = true;
      this.visibleLogo = false;
      this.$axios
        .get("/product/edit/" + this.id_shop + "/" + url_product)
        .then((response) => {
          this.product_id = response.data._id;
          this.product.name = response.data.product;
          this.product.description = response.data.description;
          this.product.category = response.data.category;
          this.product.value = response.data.value;
          this.product.promotional_value = response.data.promotional_value;
          this.product.images = response.data.images;
        });
    },
    updateProduct(product_id) {
      if (this.$refs.productForm.validate() && this.product.images.length > 0) {
        this.loading = true;
        this.$axios.put(
          "/products/" + this.id_shop + "/" + product_id,
          this.product
        );
        this.addproduct = false;
        this.product.images = [];
        this.$refs.productForm.reset();
        this.productAdded = true;
      } else if (this.product.images.length == 0) {
        this.alertImage = true;
      }
    },
    hideProduct(product_id) {
      this.$axios
        .patch("/products/hide/" + this.id_shop + "/" + product_id + "/")
        .finally(() => {
          this.loadProducts();
        });
    },
    pickAdditionalImage() {
      let input = this.$refs.additionalImageInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.additionalImageIndex == this.product.images.length) {
            this.product.images.push(e.target.result);
          } else {
            this.$set(
              this.product.images,
              this.additionalImageIndex,
              e.target.result
            );
          }
        };
        reader.readAsDataURL(file[0]);
      }
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();

        reader.onload = (e) => {
          this.product.images.push(e.target.result);
        };
        reader.readAsDataURL(file[0]);
      }
      this.visibleImage = true;
      this.visibleLogo = false;
    },
    search(search) {
      this.changingProducts = true;
      if (search.length > 0) {
        this.$axios
          .get("/search_products/" + search + "/" + this.id_shop)
          .then((response) => {
            if (response.data.length != 0) {
              this.visible = false;
              this.products = response.data;
            } else {
              this.visible = true;
              this.products = response.data;
            }
          });
      } else {
        this.changingProducts = false;
        this.visible = false;
        this.$axios.get("/products/" + this.id_shop).then((response) => {
          this.products = response.data;
        });
      }
    },
  },
  watch: {
    addproduct: function () {
      if (this.changingProducts == false) {
        this.$axios.get("/products/" + this.id_shop).then((response) => {
          this.products = response.data;
          this.loading = false;
        });
      }
    },
    "product.images": function () {
      this.alertImage = false;
      if (this.product.images.length == 0) {
        this.visibleLogo = true;
      }
    },

    productsQuery: function () {
      this.search(this.productsQuery);
    },
  },
};
</script>
